import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import icon from '@/views/system/resources/data/index';
import { Message } from "element-ui";
import { queryupRole } from "@/api/role";
import { mapActions } from "vuex";
export default {
  props: {
    roterShow: {
      type: Boolean,
      default: false
    },
    parentid: {
      type: Number,
      required: true
    },
    showing: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _ref;

    return _ref = {
      props: {
        checkStrictly: true
      },
      dialogFormVisible: false,
      valuearray: [],
      formLabelWidth: "80px",
      options: [],
      id: ""
    }, _defineProperty(_ref, "props", {
      multiple: true
    }), _defineProperty(_ref, "form", {
      title: "",
      method: "",
      listorder: 100,
      url: "",
      parentid: 0,
      icon: ''
    }), _defineProperty(_ref, "seachData", {
      title: "",
      method: "",
      listorder: 100,
      url: "",
      parentid: "",
      icon: ''
    }), _defineProperty(_ref, "parentids", 0), _defineProperty(_ref, "parentidArray", []), _defineProperty(_ref, "formLabelWidth", "80px"), _defineProperty(_ref, "langList", []), _defineProperty(_ref, "langOptions", [{
      label: '越南语',
      value: 'vi'
    }, {
      label: '俄语',
      value: 'ru-RU'
    }, {
      label: '中文',
      value: 'zh-chs'
    }]), _defineProperty(_ref, "rules", {
      title: [{
        required: true,
        message: "请输入路由名称",
        trigger: "blur"
      }],
      method: [{
        required: true,
        message: "请选择请求方式",
        trigger: "change"
      }]
    }), _ref;
  },
  computed: {
    isPrentid: {
      get: function get() {
        if (this.parentid) {
          return this.parentid;
        }
      },
      set: function set() {
        this.$emit("valChange", this.parentid);
      }
    },
    isShow: {
      get: function get() {
        if (this.showing) {
          return this.showing;
        }
      },
      set: function set(val) {
        this.$emit("changeShow", false);
      }
    }
  },
  created: function created() {
    this.parentids = this.isPrentid;
  },
  methods: _objectSpread(_objectSpread({}, mapActions("d2admin/user", ["getAllRouter", "queryFisetRouter", "queryupRoute", "addRouter", "updataRoute"])), {}, {
    format: function format(data) {
      var _this = this;

      // 格式化数据格式
      var res = [];
      data.forEach(function (item) {
        // alert(JSON.stringify(item))
        var menu = {
          value: item.id,
          //   children: [],
          label: item.title
        };

        if (item.son && item.son.length > 0) {
          menu.children = _this.format(item.son);
        }

        res.push(menu);
      });
      return res;
    },
    init: function init(index, id, item) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var queryupUser, arr, query, _query;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.dialogFormVisible = true;
                _this2.id = id;
                _this2.index = index;
                _context.next = 5;
                return _this2.getAllRouter({});

              case 5:
                queryupUser = _context.sent;
                _this2.options = _this2.format(queryupUser);
                _this2.langList = [];
                arr = []; // 添加二级路由

                _context.next = 11;
                return _this2.queryFisetRouter({
                  parentid: _this2.parentid
                });

              case 11:
                query = _context.sent;
                _this2.parentidArray = query;

                if (!(id != "t")) {
                  _context.next = 22;
                  break;
                }

                _context.next = 16;
                return _this2.queryupRoute({
                  id: id
                });

              case 16:
                _query = _context.sent;
                _this2.form = _query.route_info;
                _this2.valuearray = [];
                _this2.valuearray = _this2.queryParent(_this2.options, item.id);

                if (_this2.form.route) {
                  _this2.form.parent_id = _this2.valuearray[_this2.valuearray.length - 1] || 0;
                }

                if (_this2.form.titles && Array.isArray(_this2.form.titles)) {
                  _this2.form.titles.forEach(function (it) {
                    _this2.langList.push({
                      lang: it.language,
                      title: it.title
                    });
                  });
                }

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getValue: function getValue(val) {
      this.valuearray = val;

      if (this.valuearray.length > 0) {
        this.form.parentid = this.valuearray[this.valuearray.length - 1];
      } else {
        this.form.parentid = 0;
      }
    },
    // 查询父级ID
    queryParent: function queryParent(list, id) {
      if (!list || !id) {
        return "";
      }

      var arr = [];

      var findParent = function findParent(data, nodeId, parentId) {
        for (var i = 0, length = data.length; i < length; i++) {
          var node = data[i];

          if (node.value == nodeId) {
            arr.unshift(nodeId);

            if (nodeId === list[0].value) {
              break;
            }

            findParent(list, parentId);
            break;
          } else {
            if (node.children) {
              findParent(node.children, nodeId, node.value);
            }

            continue;
          }
        }

        return arr;
      };

      return findParent(list, id);
    },
    addLang: function addLang() {
      if (this.langList.length >= this.langOptions.length) {
        Message.warning('已添加全部语言');
        return;
      }

      this.langList.push({
        lang: '',
        title: ''
      });
    },
    removeLang: function removeLang(index) {
      this.langList.splice(index, 1);
    },
    // 过滤掉已被其它行选中的语言（保留当前行已选的值）
    getAvailableLangs: function getAvailableLangs(currentLang) {
      var selected = this.langList.map(function (item) {
        return item.lang;
      }).filter(function (l) {
        return l && l !== currentLang;
      });
      return this.langOptions.filter(function (o) {
        return !selected.includes(o.value);
      });
    },
    resetForm: function resetForm(formName) {
      var _this3 = this;

      this.$emit("changeShow", false);
      this.$nextTick(function () {
        _this3.dialogFormVisible = false;
        _this3.form = _objectSpread({}, _this3.seachData); // this.options = []

        _this3.valuearray = '';
      });
      this.id = ''; // this.$emit("changeShow", false);
    },
    submitForm: function submitForm(formName) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var query, getlist, titlesObj, index, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                titlesObj = {};

                _this4.langList.forEach(function (item) {
                  if (item.lang && item.title) {
                    titlesObj[item.lang] = item.title;
                  }
                }); // if (this.index == "f") {
                // 一级路由


                index = Math.floor(Math.random() * 100);

                if (!(_this4.id == "t")) {
                  _context2.next = 10;
                  break;
                }

                // 增加
                data = _objectSpread(_objectSpread({}, _this4.form), {}, {
                  titles: titlesObj // icon:this.form.icon?this.form.icon : icon[0].icon[index]

                });
                _context2.next = 7;
                return _this4.addRouter(data);

              case 7:
                query = _context2.sent;
                _context2.next = 13;
                break;

              case 10:
                _context2.next = 12;
                return _this4.updataRoute(_objectSpread(_objectSpread({}, _this4.form), {}, {
                  titles: titlesObj // icon:this.form.icon?this.form.icon : icon[0].icon[index]

                }));

              case 12:
                query = _context2.sent;

              case 13:
                if (query.status == 200) {
                  Message.success(query.message);

                  _this4.$emit("refreshDataList");

                  _this4.resetForm("ruleForm");
                }

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    deepFind: function deepFind(arr, condition, children) {
      // 即将返回的数组
      var main = []; // 用try方案方便直接中止所有递归的程序

      try {
        // 开始轮询
        (function poll(arr, level) {
          // 如果传入非数组
          if (!Array.isArray(arr)) return; // 遍历数组

          for (var i = 0; i < arr.length; i++) {
            // 获取当前项
            var item = arr[i]; // 先占位预设值

            main[level] = item; // 检验是否已经找到了

            var isFind = condition && condition(item, i, level) || false; // 如果已经找到了

            if (isFind) {
              // 直接抛出错误中断所有轮询
              throw Error; // 如果存在children，那么深入递归
            } else if (children && item[children] && item[children].length) {
              poll(item[children], level + 1); // 如果是最后一个且没有找到值，那么通过修改数组长度来删除当前项
            } else if (i === arr.length - 1) {
              // 删除占位预设值
              main.length = main.length - 1;
            }
          }
        })(arr, 0); // 使用try/catch是为了中止所有轮询中的任务

      } catch (err) {} // 返回最终数组


      return main;
    }
  })
};